import { createFileRoute } from '@tanstack/react-router';
import { PaymentsPage } from '@/domains/collections';

// Ruta estática: gana sobre la dinámica hermana `$section`, que sigue cubriendo el resto.
export const Route = createFileRoute('/_backoffice/collections/payments')({
    component: PaymentsPage,
});
